import { BaseConfig } from '../ServiceConfig';

export interface BankConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.BankServiceConfigData';
  url: string;
  code: string;
}

export const BankConfigurationFields: (keyof BankConfiguration)[] = [
  'url',
  'code',
];

export const BlankBankConfiguration: BankConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.BankServiceConfigData',
} as BankConfiguration;
